













import { Prop, Component, Vue } from "vue-property-decorator";
import { TaskGroup } from "@/api/task-api";
import VTaskGroup from "@/components/task/VTaskGroup.vue";

@Component({
  components: {
    VTaskGroup
  }
})
export default class TaskGroupShowModal extends Vue {
  @Prop({ required: true }) taskGroup!: TaskGroup;

  public show() {
    (this.$refs.modal as any).show();
  }

  public hide() {
    (this.$refs.modal as any).hide();
  }
}
